import type { PromptComposerBlockProps } from "../types";
import { PromptComposer } from "./PromptComposer";
import { PromptComposerSkeleton } from "../states/PromptComposerSkeleton";

export function PromptComposerBlock({
  isLoading = false,
  ...viewProps
}: PromptComposerBlockProps) {
  if (isLoading) {
    return <PromptComposerSkeleton />;
  }

  return <PromptComposer {...viewProps} />;
}
